module.exports = __webpack_public_path__ + "img/x-ray.396b38a4.gif";